import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
    FORM_FIELD_DOCUMENT_ID,
    FORM_FIELD_ISSUE_ORIGIN,
    FORM_FIELD_NOD_ID,
    FORM_FIELD_PART_REFERENCE_ASSOCIATED,
    FORM_FIELD_TECHNICAL_BULLETIN_NUMBER,
    FORM_LABEL_DOCUMENT_ID,
    FORM_LABEL_ISSUE_ORIGIN,
    FORM_LABEL_NOD_ID,
    FORM_LABEL_PART_REFERENCE_ASSOCIATED,
    FORM_LABEL_TECHNICAL_BULLETIN_NUMBER,
} from '../../../../constants/formConstants';
import { issueOrigin } from '../../../../constants/Utils';
import internalFulltextSearchMessages from '../../../../intl/afterSales/internalFulltextSearchMessages';
import internalTicketIssueOriginMessages from '../../../../intl/afterSales/internalTicketIssueOriginMessages';
import { InputFieldWithValidation } from '../../../common/InputFieldWithValidation';
import InputSelectFieldWithValidation from '../../../common/InputSelectFieldWithValidation';
import BorderRadius from '../../../common/styled/BorderRadius';

const ProblemDescriptionInternalSearchSection = ({domain, intl}, ) => {

    return (
        <>
            <h3 className="text-left mt-4 ml-4">
                <FormattedMessage {...internalFulltextSearchMessages.PROBLEM_DESCRIPTION_SECTION}/>
            </h3>
            <BorderRadius size={5} className="border border-secondary p-4 bg-white">
                <div className="form-row">
                    <div className="col-xl-3 col-md-6 col-sm-12 pb-2">
                        <InputSelectFieldWithValidation label={internalFulltextSearchMessages[FORM_LABEL_ISSUE_ORIGIN]}
                                                        field={FORM_FIELD_ISSUE_ORIGIN}
                                                        options={issueOrigin}
                                                        intlMessages={internalTicketIssueOriginMessages}
                        />
                    </div>
                    <div className="col-xl-3 col-md-6 col-sm-12 pb-2">
                        <InputFieldWithValidation label={internalFulltextSearchMessages[FORM_LABEL_PART_REFERENCE_ASSOCIATED]}
                                                  field={FORM_FIELD_PART_REFERENCE_ASSOCIATED}
                                                  maxLength={10}
                                                  isSmall
                        />
                    </div>
                    <div className="col-xl-3 col-md-6 col-sm-12 pb-2">
                        <InputFieldWithValidation label={internalFulltextSearchMessages[FORM_LABEL_NOD_ID]}
                                                  field={FORM_FIELD_NOD_ID}
                                                  maxLength={20}
                                                  isSmall
                        />
                    </div>
                    <div className="col-xl-3 col-md-6 col-sm-12 pb-2">
                        <InputFieldWithValidation label={internalFulltextSearchMessages[FORM_LABEL_DOCUMENT_ID]}
                                                  field={FORM_FIELD_DOCUMENT_ID}
                                                  maxLength={40}
                                                  isSmall
                        />
                    </div>
                    <div className="col-xl-3 col-md-6 col-sm-12 pb-2">
                        <InputFieldWithValidation label={internalFulltextSearchMessages[FORM_LABEL_TECHNICAL_BULLETIN_NUMBER]}
                                                  field={FORM_FIELD_TECHNICAL_BULLETIN_NUMBER}
                                                  maxLength={6}
                                                  isSmall
                        />
                    </div>
                </div>
            </BorderRadius>
        </>
    )
};

const mapStateToProps = (state) => ({
    roles: state.profile.userDetail.roles,
});

const mapDispatchToProps = (dispatch, props) => ({
});


export default  connect(mapStateToProps, mapDispatchToProps)(injectIntl(ProblemDescriptionInternalSearchSection));
